var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 7.33337V11.3334C14.6667 14 14 14.6667 11.3334 14.6667H4.66671C2.00004 14.6667 1.33337 14 1.33337 11.3334V4.66671C1.33337 2.00004 2.00004 1.33337 4.66671 1.33337H5.66671C6.66671 1.33337 6.88671 1.62671 7.26671 2.13337L8.26671 3.46671C8.52004 3.80004 8.66671 4.00004 9.33337 4.00004H11.3334C14 4.00004 14.6667 4.66671 14.6667 7.33337Z",
    stroke: "#68717B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33337 1.33337H11.3334C12.6667 1.33337 13.3334 2.00004 13.3334 3.33337V4.25337",
    stroke: "#68717B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.7a54d13f10c0d5cecf8cc53d333a4635.svg";
export { ForwardRef as ReactComponent };